// extracted by mini-css-extract-plugin
module.exports = {"container":"shouldOpenInWechat_container__-nweF","warn":"shouldOpenInWechat_warn__18h0K"};